﻿import { mapGetters, mapState } from 'vuex';
import VASItem from './VASItem.js';

import Flickity from 'vue-flickity';

export default {
    name: 'vas-offering',
    template: '#vas-offering-template',
    data: () => ({
        itemlist: [],
        flickityOptions: {
            initialIndex: 3,
            prevNextButtons: true,
            freeScroll: true,
            contain: true,
            pageDots: false,
            draggable: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
            // any options from Flickity can be used
        }
    }),
    components: {
        'vas-item': VASItem,
        Flickity
    },
    props: ['vasitems', 'maxNumberOfVas'],
    computed:
    Object.assign(
        mapState({            
            vasLessAllowed: state => state.offeringpage.vasLessAllowed
        })       
    ),
    methods: {       
        rotateLeft () {
            let head = this.itemlist.shift();
            this.itemlist.push(head);
        },
        rotateRight () {
            let tail = this.itemlist.pop();
            this.itemlist.unshift(tail);
        }
    },
    created: function () {
        this.itemlist = this.vasitems;

        this.$store.dispatch('setMaxNumberOfVas', this.maxNumberOfVas);
    }
}